// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viewtaskcard-container {
  padding: 20px;
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  background-color: #f9f9f9;
  box-sizing: border-box;
}

.viewtaskcard-title {
  grid-column: 1 / -1;
  font-size: 24px;
  margin-bottom: 10px;
  color: #333;
}

.viewtaskcard-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease-in-out;
}

.viewtaskcard-card:hover {
  transform: translateY(-5px);
}

.viewtaskcard-taskname {
  font-size: 18px;
  margin-bottom: 10px;
  color: #000000;
}

.viewtaskcard-card p {
  font-size: 14px;
  color: #555;
  margin: 6px 0;
}

.viewtaskcard-empty {
  grid-column: 1 / -1;
  text-align: center;
  font-size: 16px;
  color: #999;
}
@media (max-width: 768px) {
  .viewtaskcard-container {
    padding: 16px;
    gap: 14px;
  }

  .viewtaskcard-title {
    font-size: 20px;
  }

  .viewtaskcard-taskname {
    font-size: 16px;
  }

  .viewtaskcard-card p {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .viewtaskcard-container {
    padding: 12px;
    gap: 12px;
  }

  .viewtaskcard-title {
    font-size: 18px;
  }

  .viewtaskcard-taskname {
    font-size: 15px;
  }

  .viewtaskcard-card {
    padding: 16px;
  }

  .viewtaskcard-card p {
    font-size: 12.5px;
  }
}
.viewtaskcard-button-group {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  margin-top: 12px;
}

.viewtaskcard-edit-btn {
  background-color: #007bff;
  color: #fff;
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.viewtaskcard-edit-btn:hover {
  background-color: #0056b3;
}

.viewtaskcard-delete-btn {
  background-color: #dc3545;
  color: #fff;
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.viewtaskcard-delete-btn:hover {
  background-color: #b02a37;
}

@media (max-width: 480px) {
  .viewtaskcard-edit-btn,
  .viewtaskcard-delete-btn {
    padding: 7px 12px;
    font-size: 13px;
  }
}
/* ***update */
/* Background Overlay */
.update_task_form_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

/* Modal Box */
.update_task_form_popup {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
  position: relative;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
}

/* Close Button */
.update_task_form_close {
  position: absolute;
  top: 12px;
  right: 16px;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  color: #333;
}

/* Form Layout */
.update_task_form {
  display: flex;
  flex-direction: column;
}

.update_task_form label {
  margin-top: 12px;
  margin-bottom: 4px;
  font-size: 14px;
  color: #444;
}

.update_task_form input {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
}

/* Submit Button */
.update_task_form_button {
  margin-top: 20px;
  background-color: #007bff;
  color: white;
  padding: 10px;
  border: none;
  font-size: 15px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.update_task_form_button:hover {
  background-color: #0056b3;
}

/* Responsive Design */
@media (max-width: 768px) {
  .update_task_form_popup {
    margin: 0 16px;
    padding: 20px;
  }

  .update_task_form_button {
    font-size: 14px;
    padding: 9px;
  }
}

@media (max-width: 480px) {
  .update_task_form_popup {
    padding: 16px;
  }

  .update_task_form label {
    font-size: 13px;
  }

  .update_task_form input {
    font-size: 13px;
    padding: 8px;
  }

  .update_task_form_button {
    font-size: 13.5px;
    padding: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Project/viewTask.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,SAAS;EACT,4DAA4D;EAC5D,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,iBAAiB;IACjB,eAAe;EACjB;AACF;AACA,cAAc;AACd,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;AACF","sourcesContent":[".viewtaskcard-container {\n  padding: 20px;\n  display: grid;\n  gap: 16px;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  background-color: #f9f9f9;\n  box-sizing: border-box;\n}\n\n.viewtaskcard-title {\n  grid-column: 1 / -1;\n  font-size: 24px;\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.viewtaskcard-card {\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s ease-in-out;\n}\n\n.viewtaskcard-card:hover {\n  transform: translateY(-5px);\n}\n\n.viewtaskcard-taskname {\n  font-size: 18px;\n  margin-bottom: 10px;\n  color: #000000;\n}\n\n.viewtaskcard-card p {\n  font-size: 14px;\n  color: #555;\n  margin: 6px 0;\n}\n\n.viewtaskcard-empty {\n  grid-column: 1 / -1;\n  text-align: center;\n  font-size: 16px;\n  color: #999;\n}\n@media (max-width: 768px) {\n  .viewtaskcard-container {\n    padding: 16px;\n    gap: 14px;\n  }\n\n  .viewtaskcard-title {\n    font-size: 20px;\n  }\n\n  .viewtaskcard-taskname {\n    font-size: 16px;\n  }\n\n  .viewtaskcard-card p {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .viewtaskcard-container {\n    padding: 12px;\n    gap: 12px;\n  }\n\n  .viewtaskcard-title {\n    font-size: 18px;\n  }\n\n  .viewtaskcard-taskname {\n    font-size: 15px;\n  }\n\n  .viewtaskcard-card {\n    padding: 16px;\n  }\n\n  .viewtaskcard-card p {\n    font-size: 12.5px;\n  }\n}\n.viewtaskcard-button-group {\n  display: flex;\n  justify-content: flex-start;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.viewtaskcard-edit-btn {\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  padding: 8px 16px;\n  font-size: 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.viewtaskcard-edit-btn:hover {\n  background-color: #0056b3;\n}\n\n.viewtaskcard-delete-btn {\n  background-color: #dc3545;\n  color: #fff;\n  border: none;\n  padding: 8px 16px;\n  font-size: 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.viewtaskcard-delete-btn:hover {\n  background-color: #b02a37;\n}\n\n@media (max-width: 480px) {\n  .viewtaskcard-edit-btn,\n  .viewtaskcard-delete-btn {\n    padding: 7px 12px;\n    font-size: 13px;\n  }\n}\n/* ***update */\n/* Background Overlay */\n.update_task_form_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n/* Modal Box */\n.update_task_form_popup {\n  background: #fff;\n  padding: 24px;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 500px;\n  position: relative;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);\n}\n\n/* Close Button */\n.update_task_form_close {\n  position: absolute;\n  top: 12px;\n  right: 16px;\n  font-size: 24px;\n  font-weight: bold;\n  cursor: pointer;\n  color: #333;\n}\n\n/* Form Layout */\n.update_task_form {\n  display: flex;\n  flex-direction: column;\n}\n\n.update_task_form label {\n  margin-top: 12px;\n  margin-bottom: 4px;\n  font-size: 14px;\n  color: #444;\n}\n\n.update_task_form input {\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n/* Submit Button */\n.update_task_form_button {\n  margin-top: 20px;\n  background-color: #007bff;\n  color: white;\n  padding: 10px;\n  border: none;\n  font-size: 15px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.update_task_form_button:hover {\n  background-color: #0056b3;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .update_task_form_popup {\n    margin: 0 16px;\n    padding: 20px;\n  }\n\n  .update_task_form_button {\n    font-size: 14px;\n    padding: 9px;\n  }\n}\n\n@media (max-width: 480px) {\n  .update_task_form_popup {\n    padding: 16px;\n  }\n\n  .update_task_form label {\n    font-size: 13px;\n  }\n\n  .update_task_form input {\n    font-size: 13px;\n    padding: 8px;\n  }\n\n  .update_task_form_button {\n    font-size: 13.5px;\n    padding: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
